import LibraryXMLParser from '../parser/LibraryXMLParser';

export default class LibraryLoader {

    load(url) {

        let deferred = new $.Deferred();

        $.get(url)
            .done((data) => {
                var parser = new LibraryXMLParser();
                var library = parser.parseLibrary(data);
                deferred.resolve(library);
            })
            .fail(deferred.reject);;

        return deferred;
    }

}
